import * as yup from 'yup';

export const schema = yup.object().shape({
  wrap_face: yup.string().required('Error'),
  from_photo: yup.string().required('Error'),
  // INJECT
});
